import qs from "qs";
import service from "./handleRequest";
import { getToken, getAgent } from "@/utils/";

export default {
  async get(params) {
    let url = params.url;
    if (params.data) {
      for (let i in params.data) {
        url += `/${params.data[i]}`;
      }
    }
    try {
      const res = await service({
        url: url,
        method: "get",
      });
      return Promise.resolve(res ? res : {});
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async post(params) {
    try {
      const res = await service({
        url: params.url,
        method: "post",
        data: params.data,
      });
      return Promise.resolve(res ? res : {});
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async formDataPost(params) {
    try {
      const fd = new FormData();
      for (let i in params.data) {
        fd.append(i, params.data[i]);
      }
      const res = await service({
        url: params.url,
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        data: qs.stringify(params.data),
      });
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async delete(params) {
    try {
      const res = await service({
        url: params.url,
        method: "delete",
        data: params.data,
      });
      return Promise.resolve(res ? res : {});
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async put(params) {
    try {
      const res = await service({
        url: params.url,
        method: "put",
        data: params.data,
      });
      return Promise.resolve(res ? res : {});
    } catch (error) {
      return Promise.reject(error);
    }
  },
};



// WEBPACK FOOTER //
// ./src/http/index.js